module.exports = __webpack_public_path__ + "img/qrland.06e773ea.png";